import Gallery from '../../components/Gallery/Gallery';

function GalleryPage() {
  return <Gallery />;
}

export default GalleryPage;
